import * as storage from 'redux-storage';
import storageEngine from '../lib/storageEngine';

export default storage.createMiddleware(storageEngine, ['@@router/LOCATION_CHANGE']);



// WEBPACK FOOTER //
// ./app/middleware/storage.js